var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRsvpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RSVP"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#728096",
    d: "M349.9191,105.884h-17.31a8,8,0,0,0-8,8v64.687a8,8,0,1,0,16,0V156.5056h9.31a25.3108,25.3108,0,0,0,0-50.6216Zm0,34.6216h-9.31V121.884h9.31a9.3108,9.3108,0,0,1,0,18.6216Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#728096",
    d: "M174.1613,153.4371a25.3077,25.3077,0,0,0-12.07-47.5531H144.7805a8,8,0,0,0-8,8v64.687a8,8,0,0,0,16,0V156.5056h4.6858l15.0026,26.0571a8,8,0,1,0,13.8653-7.9834ZM152.7805,121.884h9.3105a9.3108,9.3108,0,0,1,0,18.6216h-9.3105Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#728096",
    d: "M220.9709,186.1887H206.1574a8,8,0,0,1,0-16h14.8135a8.0217,8.0217,0,1,0,0-16.0434h-2.5772a24.022,24.022,0,1,1,0-48.044h14.8135a8,8,0,0,1,0,16H218.3937a8.022,8.022,0,1,0,0,16.044h2.5772a24.0217,24.0217,0,1,1,0,48.0434Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#728096",
    d: "M285.5207,186.4714a8.0008,8.0008,0,0,1-7.4834-5.1718l-24.3428-64.41a8,8,0,0,1,14.9668-5.6562l16.8594,44.6088,16.8584-44.6088a8,8,0,0,1,14.9668,5.6562L293.0041,181.3A8,8,0,0,1,285.5207,186.4714Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#728096",
    d: "M173.6135,285.5505a7.9991,7.9991,0,0,1-7.6485-5.6547l-4.43-14.4463a8,8,0,1,1,15.2968-4.69l.53,1.729,40.8662-40.8662a8,8,0,1,1,11.3145,11.3135l-50.2725,50.272A8.0013,8.0013,0,0,1,173.6135,285.5505Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#728096",
    d: "M326.0139,254.219,343.17,237.0627a8,8,0,0,0-11.3144-11.3134L314.7,242.905l-17.1558-17.1557A8,8,0,1,0,286.23,237.0627l17.1562,17.1563L286.23,271.3752a8,8,0,0,0,11.3144,11.3135L314.7,265.533l17.1558,17.1557A8,8,0,1,0,343.17,271.3752Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#728096",
    d: "M416.4,432.999V300.5237a8,8,0,0,0-11.3965-7.2432l-3.5,1.6414V77.3665a8,8,0,0,0-8-8H118.507a8,8,0,0,0-8,8V294.9219l-3.5-1.6414a8,8,0,0,0-11.3965,7.2432V432.9476a7.9781,7.9781,0,0,0,.2559,3.8275c.0413.1286.105.2444.1522.37a7.9993,7.9993,0,0,0,7.5919,5.4887H408.4a8.002,8.002,0,0,0,7.6514-5.664c.0234-.0667.0583-.1267.08-.1944A7.9825,7.9825,0,0,0,416.4,432.999ZM200.7841,354.9314l-89.1736,63.7565V313.1116Zm110.4334.004L400.4,313.1116V418.6971ZM126.507,85.3665H385.5031v217.059l-89.2121,41.838-35.64-25.4815a8.0011,8.0011,0,0,0-9.3057,0L215.7106,344.26l-89.2036-41.834Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsvpIcon);
export default __webpack_public_path__ + "static/media/rsvp_icon.71174c8ae9a98c2f7e279feb04ed58c5.svg";
export { ForwardRef as ReactComponent };